import { render, staticRenderFns } from "./ShowPreview.vue?vue&type=template&id=11670cac&scoped=true&"
import script from "./ShowPreview.vue?vue&type=script&lang=js&"
export * from "./ShowPreview.vue?vue&type=script&lang=js&"
import style0 from "./ShowPreview.vue?vue&type=style&index=0&id=11670cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11670cac",
  null
  
)

export default component.exports